<template>
    <div>
        <div class="content-header">
            <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
                <el-form-item>
                    <el-button type="primary" @click="getList">查询</el-button>
                    <el-button type="success" @click="handleAdd">新增分组</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-wrap">
            <el-table :data="dataList" stripe border center :size="GCONFIG.styleTableSize"  v-loading="loading">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="platformGroupId" label="分组标示"></el-table-column>
                <el-table-column prop="platformGroupName" label="分组名称"></el-table-column>
                <el-table-column prop="platformGroupDesc" label="分组描述"></el-table-column>
                <el-table-column prop="domain" label="域名"></el-table-column>
                <el-table-column prop="mobile" label="电话"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" sortable></el-table-column>
                <el-table-column :formatter="convertStatus" label="状态"></el-table-column>
                <el-table-column label="操作" fixed="right" width="160">
                    <template slot-scope="scope">
                        <el-button type="warning " size="mini" @click="handleUpdate(scope.row)">修改</el-button>
                        <el-button type="success " size="mini" @click="handlePlatform(scope.row)">平台</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline.recordsTotal">
                </el-pagination>
            </div>
        </div>

        <el-dialog title="分组管理" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="120px">
                <el-form-item label="分组名称" :required="true">
                    <el-input v-model="form.platformGroupName" placeholder="分组名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="分组描述" :required="true">
                    <el-input v-model="form.platformGroupDesc" placeholder="用户昵称" 分组描述></el-input>
                </el-form-item>
                <el-form-item label="域名" :required="true">
                    <el-input   v-model="form.domain" placeholder="域名" clearable></el-input>
                </el-form-item>
                <el-form-item label="电话" :required="true">
                    <el-input   v-model="form.mobile" placeholder="域名" clearable></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select :popper-append-to-body="true" v-model="form.status">
                        <el-option
                                v-for="item in statusList"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateOrAdd">确 定</el-button>
            </div>
        </el-dialog>


        <el-dialog  title="平台管理" :visible.sync="dialogFormVisible1" center :fullscreen="true">
            <el-form :inline="true" :model="formInline1" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
                <el-form-item>
                    <el-button type="primary" @click="getPlatformList">查询</el-button>
                    <el-button type="success" @click="handleAddPlatform">新增</el-button>
                    <el-button type="warning" @click="dialogFormVisible1 = false">关闭</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="dataList1" stripe border center :size="GCONFIG.styleTableSize"  v-loading="loading1">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="platformId" label="标志"></el-table-column>
                <el-table-column prop="platformName" label="名称"></el-table-column>
                <el-table-column prop="platformDesc" label="描述"></el-table-column>
                <el-table-column prop="platformTypeName" label="类型"></el-table-column>
                <el-table-column prop="status" :formatter="convertStatus" label="状态"></el-table-column>
                <el-table-column prop="createTime" label="创建时间"></el-table-column>
                <el-table-column prop="apiPath" label="api路径"></el-table-column>
                <el-table-column prop="webPath" label="web路径"></el-table-column>
                <el-table-column prop="domainServer" label="后端接口"></el-table-column>
                <el-table-column prop="domainPage" label="前端页面"></el-table-column>
                <el-table-column label="操作" fixed="right" width="160">
                    <template slot-scope="scope">
                        <el-button type="warning " size="mini" @click="handleUpdatePlatform(scope.row)">修改</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :current-page="formInline1.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline1.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline1.recordsTotal">
                </el-pagination>
            </div>


            <el-dialog title="平台添加" :visible.sync="dialogFormVisible2" center  append-to-body>
                <el-form :model="form1" label-width="120px">
                    <el-form-item label="名称" :required="true">
                        <el-input v-model="form1.platformName" placeholder="名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="描述" :required="true">
                        <el-input v-model="form1.platformDesc" placeholder="昵称" 分组描述></el-input>
                    </el-form-item>
                    <el-form-item label="类型">
                        <el-select :popper-append-to-body="true" v-model="form1.platformType">
                            <el-option
                                    v-for="item in getPlatFormTypeList"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select :popper-append-to-body="true" v-model="form1.status">
                            <el-option
                                    v-for="item in statusList"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="api路径" :required="true">
                        <el-input   v-model="form1.apiPath" placeholder="api路径" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="web路径" :required="true">
                        <el-input   v-model="form1.webPath" placeholder="web路径" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="接口路径" :required="true">
                        <el-input   v-model="form1.domainServer" placeholder="接口路径" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="前端路径" :required="true">
                        <el-input   v-model="form1.domainPage" placeholder="前端路径" clearable></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible2 = false">取 消</el-button>
                    <el-button type="primary" @click="saveOrUpdatePlatForm">确 定</el-button>
                </div>
            </el-dialog>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {
        getPlatFormGroupList,
        saveOrUpdatePlatFormGroup,
        getPlatFormTypeList,
        getAllPlatFormList,
        saveOrUpdatePlatForm
    } from '../../api/api';


    //定义组件
    export default {
        data() {
            return {
                dataList: [],
                dataList1: [],
                getPlatFormTypeList:[],
                statusList: [{value: 1, name: '有效'}, {value: -1, name: '无效'}],
                loading: true,
                loading1: true,
                dialogFormVisible: false,
                dialogFormVisible1: false,
                dialogFormVisible2: false,
                formInline: {
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                formInline1: {
                    platformGroupId: "",
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                form: {
                    platformGroupId: '',
                    platformGroupName: '',
                    platformGroupDesc: '',
                    domain: '',
                    mobile: '',
                    status:'',
                },
                form1: {
                    platformId: '',
                    platformName: '',
                    platformDesc: '',
                    platformType: 1,
                    platformGroupId: 1000,
                    status: 1,
                    apiPath: '',
                    webPath: '',
                    domainServer: '',
                    domainPage: '',
                },
            }
        },
        //挂载时候执行
        mounted() {
            this.getList();
            getPlatFormTypeList().then((res) => {
                this.getPlatFormTypeList = res.data.value;
            })
        },
        methods: {
            //定义查询方法
            getList() {
                this.loading = true;
                getPlatFormGroupList(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });
                        this.formInline.recordsTotal = res.data.value.total;
                        this.dataList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleAdd() {
                this.form.platformGroupId='';
                this.form.platformGroupName='';
                this.form.platformGroupDesc='';
                this.form.domain='';
                this.form.mobile='';
                this.form.status=1;
                this.dialogFormVisible = true;
            },
            handleUpdate(row) {
                this.form.platformGroupId=row.platformGroupId;
                this.form.platformGroupName=row.platformGroupName;
                this.form.platformGroupDesc=row.platformGroupDesc;
                this.form.domain=row.domain;
                this.form.mobile=row.mobile;
                this.form.status=row.status;
                this.dialogFormVisible = true;
            },
            updateOrAdd() {
                const loading = this.$loading(this.GCONFIG.loadingParam);
                saveOrUpdatePlatFormGroup(this.form).then((res) => {
                    loading.close();
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getList();
                        this.dialogFormVisible = false;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            convertStatus(row, column, cellValue) {
                if (row.status == 1) {
                    return "有效";
                } else {
                    return "无效";
                }
            },
            handlePlatform(row){
                this.dialogFormVisible1=true;
                this.formInline1.platformGroupId=row.platformGroupId;
                this.getPlatformList();
            },
            getPlatformList() {
                this.loading1 = true;
                getAllPlatFormList(this.formInline1).then((res) => {
                    this.loading1 = false;
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });
                        this.formInline1.recordsTotal = res.data.value.total;
                        this.dataList1 = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChange1(val) {
                this.formInline1.pageSize = val;
                this.getPlatformList()
            },
            handleCurrentChange1(val) {
                this.formInline1.currentPage = val;
                this.getPlatformList()
            },
            handleAddPlatform() {
                this.dialogFormVisible2=true;
                this.form1.platformGroupId=this.formInline1.platformGroupId;
            },
            handleUpdatePlatform(row){
                this.dialogFormVisible2=true;
                this.form1= {
                        platformId: row.platformId,
                        platformName: row.platformName,
                        platformDesc: row.platformDesc,
                        platformType: row.platformType,
                        platformGroupId: this.formInline1.platformGroupId,
                        status: row.status,
                        apiPath: row.apiPath,
                        webPath: row.webPath,
                        domainServer: row.domainServer,
                        domainPage: row.domainPage
                }
            },
            saveOrUpdatePlatForm(){
                const loading = this.$loading(this.GCONFIG.loadingParam);
                saveOrUpdatePlatForm(this.form1).then((res) => {
                    loading.close();
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getPlatformList();
                        this.dialogFormVisible2 = false;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/system/platform.vue